import React, { useEffect, useState } from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PartnerForm from '../components/PartnerForm';
import { useGetPartnerHandler } from '../dataHandlers/getPartnerHandler';
import { useMutatePartnerHandler } from '../dataHandlers/mutatePartnerHandler';

export default function PartnerEditPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { partner, isLoading: isLoadingData } = useGetPartnerHandler(id);
  const { onSubmit, error, isPending } = useMutatePartnerHandler({
    onSuccess: () => navigate('/partners'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  if (isLoadingData || !partner) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <PartnerForm
        onSubmit={(payload) => onSubmit({ ...payload, id: partner.id }, true)}
        onCancel={() => navigate('/partners')}
        initialData={partner}
        apiErrors={error}
        isLoading={isPending || isLoadingData || isSubmitting}
        edit={true}
      />
    </Stack>
  );
}
